// @ts-nocheck
import { useState } from 'react';
import { Dialog } from "primereact/dialog";
import { ListBox } from 'primereact/listbox';
import { TerrainSiderComponents } from './TerrainSiderComponents';
import "../assets/functionalComponents/_dialog.scss"


export const BaseLayerList = (props: { BaseLayer: any; onHide: (arg0: string) => any; }) => {
    const [selectedlayer, setSelectedlayer] = useState(window.BASE_LAYERS[0]);
    const [baseLayerList] = useState(window.BASE_LAYERS);

    const baseLayerOnChange = (layers) => {
        window.main.OView.setBaseLayer({
            url: layers.URL,
            identifier: layers.ID,
            urlTemplate: window.TERRAIN_SERVER.URLTemplate
        });
        setSelectedlayer(layers);
    }
    return (
        <Dialog header="底圖列表" visible={props.BaseLayer} modal={false} keepInViewport={false} onHide={() => props.onHide('BaseLayer')}>
            <TerrainSiderComponents />
            <ListBox value={selectedlayer} options={baseLayerList} onChange={(e) => baseLayerOnChange(e.value)} optionLabel="TITLE" />
        </Dialog>
    );
}